import { useCallback, useEffect, useState } from "react";
import {
  fetchLimitsEnrichItemList,
  type LimitsEnrichItem,
} from "../api/limitsEnrichItem";
import { getApiErrorMessage } from "../utils/getApiErrorMessage";

export const useLimitsEnrichItemList = (enabled = true) => {
  const [data, setData] = useState<LimitsEnrichItem[]>([]);
  const [loading, setLoading] = useState(enabled);
  const [error, setError] = useState<string | null>(null);
  const [reloadToken, setReloadToken] = useState(0);

  const refetch = useCallback(() => {
    setReloadToken((token) => token + 1);
  }, []);

  const applySaved = useCallback((item: LimitsEnrichItem) => {
    if (!item.id) return;

    setData((current) => {
      if (item.active === false) {
        return current.filter((row) => row.id !== item.id);
      }

      const index = current.findIndex((row) => row.id === item.id);
      if (index === -1) return [...current, item];
      const next = [...current];
      next[index] = item;
      return next;
    });
  }, []);

  useEffect(() => {
    if (!enabled) {
      setLoading(false);
      return;
    }

    let cancelled = false;
    setLoading(true);
    setError(null);

    fetchLimitsEnrichItemList()
      .then((items) => {
        if (!cancelled) setData(items);
      })
      .catch((err: unknown) => {
        if (!cancelled) {
          setError(getApiErrorMessage(err, "Не удалось загрузить каталог докупки"));
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [enabled, reloadToken]);

  return { data, loading, error, refetch, applySaved };
};
